module.exports = __webpack_public_path__ + "img/dpd.b484c0f7.svg";